// Controls
import { useDndDragLayerStyles } from "./DndDragLayer.styles";
// Utilities
import React, { useMemo } from "react";
import { useDragLayer } from "react-dnd";
import { customizeStyles } from "../utilities/StyleUtilities";
/**
 * Custom drag layer to render a preview of the dragged item.
 */ export const DndDragLayer = ()=>{
    const { isDragging, item, initialOffset, currentOffset } = useDragLayer((monitor)=>({
            item: monitor.getItem(),
            initialOffset: monitor.getInitialSourceClientOffset(),
            currentOffset: monitor.getSourceClientOffset(),
            isDragging: monitor.isDragging()
        }));
    const styles = customizeStyles(useDndDragLayerStyles(), item?.previewElement?.styles);
    const previewItem = useMemo(()=>{
        return item?.previewElement?.render?.() ?? null;
    }, [
        item
    ]);
    /**
     * Get inline styles for the preview item as makeStyles cannot be used here.
     * @param initialOffset Initial offset of the dragged item when the drag started
     * @param currentOffset Current offset of the dragged item
     */ const getPreviewStyles = ()=>{
        if (!initialOffset || !currentOffset) {
            return {
                display: "none"
            };
        }
        // Get default transform to move the preview item to the current position
        const { x, y } = currentOffset;
        const transform = `translate(${x}px, ${y}px)`;
        return {
            transform
        };
    };
    if (!isDragging) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.root
    }, /*#__PURE__*/ React.createElement("div", {
        style: getPreviewStyles(),
        className: styles.container
    }, previewItem));
};
